import { useCrossProductUrlWrapper } from '@atlassiansox/analytics-cross-product-interaction-client';

import { fg } from '@atlaskit/platform-feature-flags';

import type { TownsquareApp } from '../store/context';

export const useGetCrossProductWrappedUrl = (
	bridge: string,
	url: string,
	app?: TownsquareApp,
): string => {
	const sourceApp = app ?? 'teams';
	const buildUrlWithAnalyticsParams = useCrossProductUrlWrapper({
		bridge,
		product: 'townsquare',
		subProduct: sourceApp,
	});

	const isCrossAppMauEnabled = fg('townsquare_teams_cross_app_mau');

	return app !== undefined && app !== 'teams' && isCrossAppMauEnabled
		? buildUrlWithAnalyticsParams(url)
		: url;
};
